import Fetchers from 'core/fetchers';

const Loaders = {};

Loaders.loadSimilarProductImgs = (similarProductsPath) => {
  Fetchers.fetchJs(similarProductsPath, 'GET').then(() => {
    TeePublic.Utility.unveil_images('.jsSimilarProductImg');
  });
}

Loaders.loadRecentlyViewedProductImgs = (recentlyViewedPath) => {
  // Render the images after fetching the data
  Fetchers.fetchJs(recentlyViewedPath, 'GET').then(() => {
    TeePublic.Utility.unveil_images('.jsRecentlyViewedProductImg');
  });
}

export default Loaders;
